import script from "./Onboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./Onboarding.vue?vue&type=script&setup=true&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=4039872c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4039872c"]])

export default __exports__